const dismissSpaceSelector = (state) => ({
  ...state,
  openTimestamp: null,
  openCorrelationId: null,
});

export default dismissSpaceSelector;
